var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28947 15.2022C1.11324 15.2014 0.94136 15.1475 0.796235 15.0475C0.651111 14.9475 0.539482 14.8061 0.47591 14.6418C0.412338 14.4774 0.399772 14.2977 0.439852 14.1261C0.479932 13.9545 0.570797 13.7989 0.700596 13.6797L7.2071 7.76824L0.700596 1.84887C0.611571 1.77268 0.538755 1.67938 0.486469 1.57452C0.434184 1.46965 0.403494 1.35535 0.396219 1.2384C0.388945 1.12145 0.405234 1.00423 0.444121 0.893697C0.483009 0.783161 0.543701 0.681562 0.622599 0.594927C0.701496 0.508292 0.796991 0.438387 0.903417 0.389358C1.00984 0.34033 1.12503 0.313177 1.24215 0.30951C1.35927 0.305844 1.47593 0.325739 1.58522 0.368015C1.6945 0.41029 1.79418 0.474086 1.87835 0.555616L9.09622 7.12162C9.18631 7.20362 9.25828 7.30353 9.30753 7.41496C9.35677 7.52638 9.38221 7.64686 9.38221 7.76868C9.38221 7.8905 9.35677 8.01098 9.30753 8.1224C9.25828 8.23382 9.18631 8.33374 9.09622 8.41574L1.87835 14.9747C1.70947 15.127 1.49947 15.2022 1.28947 15.2022Z",
    fill: "#1D51D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.c5c2b1056a317d8b9e59ed85cc09dec8.svg";
export { ForwardRef as ReactComponent };